<template>
  <b-container class="card-container">
    <b-card>
      <template v-slot:header>
        <span class="breadcrumbs"><b-link :to="{name: `${collection}s`}">{{collection | capitalise | pluralise}}</b-link> / <b-link :to="{name: `${collection}`}">{{item ? item.name : ''}}</b-link> / Edit</span>
        <!-- <b-button size="sm" variant="danger float-right" @click="delete_item">Delete</b-button> -->
      </template>

      <Loading v-if="item === undefined"/>
      <Error v-else-if="item === null" code="404"></Error>
      <div v-else>

        <b-form @submit.stop.prevent="edit_item">
          <b-form-group label="Name:" invalid-feedback="Must be greater then 4 character">
            <b-form-input v-model="item.name" required placeholder="Enter name" :state="validate_state('name')"></b-form-input>
          </b-form-group>

          <b-form-group>
            <b-form-select v-model="item.status" :options="['complete', 'error', 'pending', 'processing', 'training']" ></b-form-select>
          </b-form-group>

          <div class='mb-2' v-if="item.provider !== 'synthesia'">
            <h4>Training</h4>
            <audio v-if='item.training_audio_url' :src="item.training_audio_url" controls></audio>
          </div>

          <div v-if="profile.role === 'admin' && item.provider === 'synthesia'" class='mb-2'>
            {{item.gender}}<br />
            {{item.accent}}<br />
            {{item.provider_id}}<br />
            {{item.language}}
          </div>

          <div v-if="profile.role === 'admin' && item.provider !== 'synthesia'" class='mb-2'>
            <h4>Descript</h4>
            <div v-if="!item.descript_voice_id && item.descript_username" class="mb-2">
              <LoadingButton :loading="descript_setup_loading" @click="descript_setup">Setup Descript (once overdub voice is complete)</LoadingButton>
            </div>

            <LoadingButton :loading="check_if_voice_is_ready_loading" v-if="item.descript_voice_id" @click="check_if_voice_is_ready_api" class='mr-2'>Check descript voice status</LoadingButton>
            <LoadingButton variant='warning' class='mr-2' v-if="!item.descript_username" :disabled="!item.training_audio_url" :loading="signup_and_submit_training_data_loading" @click="signup_and_submit_training_data">Signup and submit training data</LoadingButton>
            <LoadingButton variant='danger' @click="clear_descript" v-if="item.descript_voice_id || item.descript_username">Clear Descript</LoadingButton>

            <b-form-group class="mt-4">
              <b-form-input v-model="item.descript_username" placeholder="john@example.com"></b-form-input>
            </b-form-group>
            <b-form-group>
              <b-form-input v-model="item.descript_password" placeholder="*********" ></b-form-input>
            </b-form-group>

            <b-table-simple responsive bordered small>
              <b-tr v-if="item.descript_membership">
                <b-td>Start</b-td>
                <b-td>{{item.descript_membership.current_period_start_date | datetime}}</b-td>
              </b-tr>
              <b-tr v-if="item.descript_membership">
                <b-td>End</b-td>
                <b-td>{{item.descript_membership.current_period_end_date | datetime}}</b-td>
              </b-tr>
              <b-tr v-if="item.descript_membership">
                <b-td>Tier</b-td>
                <b-td>{{item.descript_membership.tier}}</b-td>
              </b-tr>
              <b-tr v-if="item.descript_membership">
                <b-td>Ends soon</b-td>
                <b-td><b-badge>{{item.descript_membership.ends_soon}}</b-badge></b-td>
              </b-tr>
              <b-tr v-if="item.descript_membership">
                <b-td>Subscription status</b-td>
                <b-td>{{item.descript_membership.subscription_status}}</b-td>
              </b-tr>
              <b-tr>
                <b-td>Voice ID</b-td>
                <b-td>{{item.descript_voice_id}}</b-td>
              </b-tr>
              <b-tr>
                <b-td>Project ID</b-td>
                <b-td>{{item.descript_project_id}}</b-td>
              </b-tr>
              <b-tr>
                <b-td>Last checked</b-td>
                <b-td>{{item.latest_descript_voice_status_date | datetime}}</b-td>
              </b-tr>
              <b-tr>
                <b-td>Trial started</b-td>
                <b-td>{{item.descript_trial_started | datetime}}</b-td>
              </b-tr>
              <b-tr>
                <b-td>Voice ID</b-td>
                <b-td>{{item.descript_voice_id}}</b-td>
              </b-tr>
            </b-table-simple>
          </div>

          <LoadingButton type="submit" variant='primary' :loading="is_saving">Save</LoadingButton>

          <p class="muted mt-4"><small>Created {{item.created | datetime}}<br>Updated {{item.updated | datetime}}</small></p>
        </b-form>

      </div>
    </b-card>
  </b-container>
</template>

<script>
import { db } from '@/main.js'
import { required, minLength } from "vuelidate/lib/validators"
import ItemMixin from "@/mixins/Item.js"
import api from '@/lib/api.js'


export default {
  metaInfo: {title: 'Clone edit'},
  mixins: [ItemMixin],
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.id)
    }
  },
  validations: {
    item: {
      name: {required, minLength: minLength(3)},
    }
  },
  data() {
    return {
      collection: 'voice',
      descript_setup_loading: false,
      check_if_voice_is_ready_loading: false,
      signup_and_submit_training_data_loading: false,
    }
  },
  methods: {
    async clear_descript() {
      this.item.descript_username = null
      this.item.descript_password = null
      this.item.descript_voice_id = null
      this.item.descript_project_id = null
      this.item.refresh_token = null
      this.item.latest_descript_voice_status_date = null
      this.item.descript_token = null
      this.item.descript_token_updated = null
    },
    async check_if_voice_is_ready_api() {
      this.check_if_voice_is_ready_loading = true
      let result = await api.check_if_voice_is_ready_api(this.item.id)
      this.$swal({title: `Voice ${result.data.ready ? '' : 'not'} ready`, text: `Reason: ${result.data.reason}`, icon: 'info'})
      this.check_if_voice_is_ready_loading = false
    },
    async signup_and_submit_training_data() {
      this.signup_and_submit_training_data_loading = true
      await api.signup_and_submit_training_data(this.item.id)
      this.signup_and_submit_training_data_loading = false
    },
    async descript_setup() {
      this.descript_setup_loading = true

      let response = await api.descript_setup(this.item.id)
      if (response.data.error) {
        this.descript_setup_loading = false
        this.$swal({title: 'Error', text: response.data.error_message, icon: 'warning'})
        return
      }

      this.descript_setup_loading = false
    },
  }
}
</script>

<style>

</style>
